import { default as CallIcon } from "assets/svgs/voitek_call";
import { useContext } from "react";
import { toast } from "react-toastify";
import {
  CALL_PROVIDERS,
  getCustomerPhoneNumberByPhoneType,
  TOAST_MESSAGE_CSS,
} from "modules/utilities/utility";
import _ from "lodash";
import { Tooltip } from "antd";
import { useCall } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { ActiveEngagement } from "./ShowEngagement";
import { useCallingStore } from "modules/navbar/top/store/store";

const ubonaButtonStyle = {
  position: "fixed",
  bottom: "270px",
  right: "20px",
  zIndex: 10000,
  cursor: "pointer",
  border: "none",
  background: "none",
  padding: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "transform 0.2s ease",
};

const UbonaIntegration = (props) => {
  const { callDndFlag, provider, customerData, phoneType = "phone" } = props;
  const { activeEngagement } = useContext(ActiveEngagement);
  const { updateCallingStatus } = useCallingStore();
  const { call } = useCall();
  const { setToaster } = useToast();

  const handleCallStart = async () => {
    try {
      if (callDndFlag) {
        toast("Customer is in DND mode, Please do not call", TOAST_MESSAGE_CSS);
        return;
      }
      updateCallingStatus("ubonaCalling", true);
      const caseId = customerData?.id;
      const engagementId = activeEngagement ?? null;

      let customerNumber = getCustomerPhoneNumberByPhoneType(
        customerData,
        phoneType
      );
      if (customerNumber.startsWith("+91")) {
        customerNumber = customerNumber.slice(3);
      }
      if (!customerNumber) return;
      const response = await call(
        caseId,
        {},
        engagementId,
        customerNumber,
        setToaster,
        false,
        CALL_PROVIDERS.UBONA
      );

      const providerName = _.get(response, ["result", "provider_name"], null);
      if (providerName === CALL_PROVIDERS.UBONA) {
        //Send this event for open the iframe modal
      }
    } catch (error) {
      console.error("Error @ UBONA", error);
    }
  };

  const ubonaOpenOrFocusTab = async () => {
    try {
      const ubonaUrl = new URL(
        "https://traya-health-udial.ubona.com/UDial/index.html"
      );
      window.open(ubonaUrl.toString(), "_blank");
    } catch (error) {
      console.error("Error faild to open ubona tab", error);
      toast.error("Error faild to open ubona tab");
    }
  };
  return (
    <div
      className={`text-center ${
        callDndFlag ? "disabled-action" : "cursor-pointer"
      }`}
    >
      <Tooltip placement="bottom" title="Ubona">
        <div className="d-flex justify-content-center gap-2 text-wrap">
          <span
            className="button callStart"
            name="callStartButton"
            type="button"
            value="call"
            onClick={handleCallStart}
          >
            <CallIcon color="#FEBF3B" />
          </span>
        </div>
      </Tooltip>
      <button
        style={ubonaButtonStyle}
        onClick={ubonaOpenOrFocusTab}
        onMouseOver={(e) => {
          const target = e.currentTarget;
          target.style.transform = "scale(1.1)";
        }}
        onMouseOut={(e) => {
          const target = e.currentTarget;
          target.style.transform = "scale(1)";
        }}
      >
        <img
          src="https://www.ubona.com/wp-content/uploads/2024/08/Ubonaheaderlogo.svg"
          width={55}
          alt="icon"
        />
      </button>
    </div>
  );
};

export default UbonaIntegration;
